module.exports = __webpack_public_path__ + "static/media/71f4d05f-476d-44e4-819a-10a51f9a148e.59a3f632.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/71f4d05f-476d-44e4-819a-10a51f9a148e.jpg
// module id = 826
// module chunks = 0